/* import Calendar from '../Images/calendar.png';
import Docs from '../Images/docs.png';
import Excel from '../Images/excel.png';
import Figma from '../Images/figma.png';
import Form from '../Images/forms.png';
import Github from '../Images/github.png';
import Medium from '../Images/medium.png';
import Meet from '../Images/meet.png';
import Notion from '../Images/notion.png';
import Photoshop from '../Images/photoshop.png';
import Powerpoint from '../Images/powerpoint.png';
import Sheets from '../Images/sheets.png';
import Slides from '../Images/slides.png';
import Spotify from '../Images/spotify.png';
import Twitter from '../Images/twitter.png';
import Word from '../Images/word.png';
import LocalFile from '../Images/fileIcon.png'; */

const Calendar = '../../assets/images/calendar.png';
const Docs = '../../assets/images/docs.png';
const Excel = '../../assets/images/excel.png';
const Figma = '../../assets/images/figma.png';
const Form = '../../assets/images/forms.png';
const Github = '../../assets/images/github.png';
const Medium = '../../assets/images/medium.png';
const Meet = '../../assets/images/meet.png';
const Notion = '../../assets/images/notion.png';
const Photoshop = '../../assets/images/photoshop.png';
const Powerpoint = '../../assets/images/powerpoint.png';
const Sheets = '../../assets/images/sheets.png';
const Slides = '../../assets/images/slides.png';
const Spotify = '../../assets/images/spotify.png';
const Twitter = '../../assets/images/twitter.png';
const Word = '../../assets/images/word.png';
const LocalFile = '../../assets/images/fileIcon.png';

export const LocalIconProvider = (title) => {
    let iconToReturn =
        title === 'Calendar'
            ? Calendar
            : title === 'Docs'
            ? Docs
            : title === 'Excel'
            ? Excel
            : title === 'Figma'
            ? Figma
            : title === 'Form'
            ? Form
            : title === 'Github'
            ? Github
            : title === 'Medium'
            ? Medium
            : title === 'Meet'
            ? Meet
            : title === 'Notion'
            ? Notion
            : title === 'Photoshop'
            ? Photoshop
            : title === 'Powerpoint'
            ? Powerpoint
            : title === 'Sheets'
            ? Sheets
            : title === 'Slides'
            ? Slides
            : title === 'Spotify'
            ? Spotify
            : title === 'Twitter'
            ? Twitter
            : title === 'Word'
            ? Word
            : LocalFile;
    return iconToReturn;
};
